import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { SkinProvider } from '@/components/SkinContext';
import { AdminProvider, AdminPanel } from '@/components/AdminPanel';
import Home from '@/pages/Home';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <SkinProvider>
          <AdminProvider>
            <Router>
              <Routes>
                <Route path="/" element={<Home />} />
              </Routes>
            </Router>
            <AdminPanel />
            <Toaster />
          </AdminProvider>
        </SkinProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
